/* eslint-disable jsx-a11y/anchor-is-valid */
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaGithub, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import '../css/main.css';

function Footer() {
  return (
    <>
    <footer className="bg-teal-900 text-white pt-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        
        {/* Company Info as Text */}
        <div>
          <h1 className="text-xl font-black tracking-wide mb-3 text-white">EDGES DESIGN GROUP</h1>
          <p className="text-gray-300 leading-relaxed text-sm">
            At Edges, we help businesses grow through innovative architectural and construction solutions. We turn ideas into enduring realities.
          </p>
          <div className="flex gap-4 mt-5">
            <a href="#" aria-label="Twitter"><FaTwitter className="text-xl hover:text-teal-300 transition" /></a>
            <a href="#" aria-label="Facebook"><FaFacebookF className="text-xl hover:text-teal-300 transition" /></a>
            <a href="#" aria-label="LinkedIn"><FaLinkedinIn className="text-xl hover:text-teal-300 transition" /></a>
            <a href="#" aria-label="Github"><FaGithub className="text-xl hover:text-teal-300 transition" /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-3 text-sm">
            <li><a href="/" className="hover:text-teal-300 transition">Home</a></li>
            <li><a href="/about" className="hover:text-teal-300 transition">About</a></li>
            <li><a href="/services" className="hover:text-teal-300 transition">Services</a></li>
            <li><a href="/contacts" className="hover:text-teal-300 transition">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
          <ul className="space-y-4 text-sm">
            <li className="flex items-center gap-2"><FaPhoneAlt className="text-teal-400" /> +250 788 570 601</li>
            <li className="flex items-center gap-2"><FaEnvelope className="text-teal-400" /> contact@edges.com</li>
            <li className="flex items-center gap-2"><FaClock className="text-teal-400" /> Mon-Fri: 8:00 - 17:00</li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Stay Updated</h3>
          <p className="text-gray-300 text-sm mb-4">Subscribe to our newsletter for the latest insights and updates.</p>
          <form className="flex flex-col sm:flex-row items-center gap-3">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-4 py-2 rounded text-gray-800 placeholder-gray-500 focus:outline-none"
            />
            <button className="bg-teal-600 hover:bg-teal-500 px-5 py-2 text-sm font-semibold rounded text-white transition">
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-teal-950 text-center py-4 mt-10">
        <p className="text-gray-400 text-xs">
          &copy; {new Date().getFullYear()} Edges Design Group. All rights reserved.
        </p>
      </div>
    </footer>
  </>
  );
}

export default Footer;
